import { Fragment } from "react";
import { useSelector } from "react-redux";
import {
  Toolbar,
  ToolbarItem,
  ToolbarSeparator,
  Button,
} from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { Form } from "../../../components/form";
import { Splitter } from "@progress/kendo-react-layout";
import { ImportSchedulePageForm } from "./importschedulepageform";
import { NavLink } from "react-router-dom";
import { ReactComponent as ImportIcon } from "../../../icons/import.svg";
import Cookies from "js-cookie";
import { canCreateSchedule } from "../../../routing/authorizationhandlers";
import { useTranslation } from "react-i18next";

const toolbarRenderer = (props) => {
  const { currentTheme, currentUser, pageState, onToolsToggle, onClose, t } =
    props;

  const toolsVisibleIcon = pageState.toolsVisible ? "unpin" : "pin";
  const toolsVisibleTitle = pageState.toolsVisible
    ? t("datasets.create.hide")
    : t("datasets.create.show");

  return (
    <Toolbar className="dataset-toolbar">
      {currentUser.IsAuthenticated && (
        <Fragment>
          <ToolbarItem>
            <Button
              disabled={pageState.processing}
              style={{ color: currentTheme.primary }}
              icon={toolsVisibleIcon}
              onClick={props.onToolsToggle}
            >
              {toolsVisibleTitle}
            </Button>
          </ToolbarItem>
          <ToolbarSeparator />
          <ToolbarItem>
            <Button
              disabled={pageState.processing}
              style={{ color: currentTheme.primary }}
              icon="close"
              onClick={onClose}
            >
              {t("datasets.create.close")}
            </Button>
          </ToolbarItem>
        </Fragment>
      )}
    </Toolbar>
  );
};

export const ImportSchedulePageBody = (props) => {
  const {
    onNew,
    onSave,
    onClose,
    onDelete,
    onErrorbarClose,
    updateDirtyState,
    onSplitterChange,
    onToolsToggle,
    onChangeDataset,
    onChangeFormValue,
    onRecurrencyOptionChange,
    loadGoogleConnectorSheets,
    loadGoogleConnections,
    getGoogleSheetId,
    ...other
  } = props;

  const currentTheme = useSelector((state) => state.currentTheme);
  const currentUser = useSelector((state) => state.currentUser);
  const pageState = useSelector((state) => state.importSchedulePage);
  const appearance = useSelector((state) => state.appearance); 
  const { t } = useTranslation();

  return (
    <Fragment>
      {pageState.processing && (
        <div className="page-loader">
          <Loader
            size={"large"}
            type="infinite-spinner"
            themeColor={"primary"}
          />
          {pageState.processingText && (
            <div style={{ fontSize: 13, color: currentTheme.primary }}>
              {pageState.processingText}
            </div>
          )}
        </div>
      )}
      {pageState.pageLoaded && (
        <Splitter
          style={{ border: "none" }}
          panes={pageState.panes}
          onChange={onSplitterChange}
        >
          <div className="create-schedule-page-manager">
            {canCreateSchedule && (
              <div className="new-dataset">
                <NavLink to="/createschedule">
                  <div className="new-container">
                    <div>
                      <div className="k-icon k-i-plus"></div>
                      <div>{t("schedule.createschedule")}</div>
                    </div>
                  </div>
                </NavLink>
                <NavLink onClick={onNew}>
                  <div className="new-container">
                    <div>
                      <ImportIcon width={15} className="k-icon" />
                      <div>{t("schedule.importSchedule")}</div>
                    </div>
                  </div>
                </NavLink>
              </div>
            )}
          </div>
          <div className="create-schedule-page-wrapper">
            <Form
              className="create-schedule-page-form"
              currentTheme={currentTheme}
              currentUser={currentUser}
              toolbarRenderer={toolbarRenderer}
              t={t}
              onNew={onNew}
              onToolsToggle={onToolsToggle}
              onSave={onSave}
              onClose={onClose}
              onDelete={onDelete}
              errorMessages={pageState.formServerErrors}
              onErrorbarClose={onErrorbarClose}
              pageState={pageState}
              onChangeDataset={onChangeDataset}
              onChangeFormValue={onChangeFormValue}
              onRecurrencyOptionChange={onRecurrencyOptionChange} 
              loadGoogleConnectorSheets={loadGoogleConnectorSheets}
              loadGoogleConnections={loadGoogleConnections}
              getGoogleSheetId={getGoogleSheetId}
            >
              <ImportSchedulePageForm
                updateDirtyState={updateDirtyState}
                onChangeDataset={onChangeDataset}
                onChangeFormValue={onChangeFormValue}
                onRecurrencyOptionChange={onRecurrencyOptionChange} 
                loadGoogleConnectorSheets={loadGoogleConnectorSheets}
                loadGoogleConnections={loadGoogleConnections}
                getGoogleSheetId={getGoogleSheetId}
              />
            </Form>
          </div>
        </Splitter>
      )}
      <style>
        {`                  
                .create-schedule-page > .content
                {
                    
                }

                 .create-schedule-page .k-splitter{
                      flex-direction:${
                        appearance.isRightToLeft ? "row-reverse" : "row"
                      } 
                    }
                      
                    .create-schedule-page .k-splitter .k-pane{
                      direction:${appearance.isRightToLeft ? "rtl" : "ltr"} 
                    }

                   
                  .create-schedule-page .create-schedule-page-wrapper{
                    border: ${currentTheme.pageFormBorder};   
                    height:100%;
                         height:100%; direction:${
                           appearance.isRightToLeft ? "rtl" : "ltr"
                         } 
                    } 

                    .create-schedule-page .create-schedule-page-wrapper .k-upload{
                     
                      direction:${appearance.isRightToLeft ? "ltr" : "ltr"} 
                    }

                .create-schedule-page > .content .create-schedule-page-manager
                {
                    border: ${currentTheme.managerBorder};
                    border-radius: ${currentTheme.pageBorderRadius};
                    background-color: ${currentTheme.componentBgFaded};
                    height:100%;
                }
                
                .create-schedule-page > .content .create-schedule-page-manager .k-dropdownlist
                {
                    /*bg of datasets dropdown*/
                    background-color: transparent;
                    color: ${currentTheme.componentText};
                }

                /*.create-schedule-page .content .create-schedule-page-manager .k-dropdownlist:focus
                {
                    box-shadow: none;   
                }*/


                     /*new dataset*/
                    .create-schedule-page .new-dataset 
                    {
                        display: flex;
                        flex-direction:column;
                        justify-content: center;
                        align-items: center;
                        padding: 32px 16px;

                    }

                    .create-schedule-page .new-dataset a
                    {
                        width: 100%;
                        display: inline-block;
                        color: ${currentTheme.componentText};
                        text-decoration: none;
                        margin-bottom:15px;
                    }

                    .create-schedule-page .new-dataset .new-container
                    {
                        padding: 16px 16px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border: 1px solid ${currentTheme.separatorColor};
                        border-radius: 8px;
                        color: ${currentTheme.componentText};   
                        opacity: 0.5;
                    }
                    
                    .create-schedule-page .new-dataset .new-container:hover
                    {
                        cursor: pointer;
                        background-color: ${currentTheme.componentBgFaded};
                        border-color: ${currentTheme.separatorColor};
                        opacity: 1;
                        transition: opacity 1000ms;
                    }

                    .create-schedule-page .new-dataset .new-container > div
                    {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }                    

                    .create-schedule-page .new-dataset .new-container .k-icon
                    {
                        color: ${currentTheme.componentText};   
                        font-size: 20px;
                        font-weight: 300; 
                        margin-right: ${appearance.isRightToLeft ? "0" : "4px"};
                        margin-left: ${appearance.isRightToLeft ? "4px" : "0"};
                    }    
                    
                    .create-schedule-page .new-dataset .new-container svg
                    {
                        color: ${currentTheme.componentText};   
                        margin-right: 4px;
                    }                                   


                .create-schedule-page > .content .create-schedule-page-manager .panel-datasets .k-input::placeholder
                {
                    color: ${currentTheme.componentText};
                    /*font-style: italic;*/
                }

                .create-schedule-page > .content .create-schedule-page-manager .k-panelbar
                {
                    /*required*/
                    background-color: transparent;
                }

                .create-schedule-page > .content .create-schedule-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link .k-icon
                {
                    /*the arrow near every panel header*/
                    color: ${currentTheme.touchColor}!important;
                    margin-right: 6px;
                }

                .create-schedule-page > .content .create-schedule-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link
                {
                    /*the span in the above <li> i.e. the title of every group in the manager: datasets, datasets, columns and description*/  
                    background-color: transparent;
                    color: ${currentTheme.touchColor};
                    border-bottom: 1px solid ${currentTheme.separatorColor}; 
                }

                .create-schedule-page > .content .create-schedule-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link:hover
                {
                    /*the above hovered - do nothing*/
                }

                .create-schedule-page > .content .create-schedule-page-manager .datasets .list-item:hover
                {
                    /*expression item hover */
                    background-color: ${currentTheme.componentBorderColor};
                    cursor: pointer;
                }

                .create-schedule-page > .content .create-schedule-page-manager .dataset,
                .create-schedule-page > .content .create-schedule-page-manager .description,
                .create-schedule-page > .content .create-schedule-page-manager .k-child-animation-container
                {
                    /*bg color of exp. manager elements */
                }

                .create-schedule-page > .content .create-schedule-page-manager .list-container
                {
                    /*bg of both the exp. and columns Lists*/
                    background-color: transparent;
                    padding : 0;/*can add padding to list items*/
                }

                .create-schedule-page > .content .create-schedule-page-manager .k-panelbar-header
                {
                    background-color: transparent;
                }

                .create-schedule-page > .content .create-schedule-page-manager .k-panelbar-content
                {
                    background-color: transparent;
                }

                .create-schedule-page > .content .create-schedule-page-manager .datasets .list-item-data-type-icon
                {
                    /*first icon in datasets list*/
                    padding-left: 12px
                }

                .create-schedule-page > .content .create-schedule-page-manager .datasets .list-item-expression-icon
                {
                    /*second icon in datasets list*/
                    padding: 5px 3px;                 
                }

                .create-schedule-page > .content .create-schedule-page-manager .datasets .list-item-title
                {
                    vertical-align: middle;/*fine tuning*/
                }

                .create-schedule-page > .content .create-schedule-page-manager .columns
                {
                    /*space above the first column in the list*/
                    padding-top: 6px;
                }

                .create-schedule-page > .content .create-schedule-page-manager .columns .list-item-data-type-icon
                {
                    /*first icon in columns list*/
                    padding-left: 12px;
                }

                .create-schedule-page > .content .create-schedule-page-manager .columns .list-item-title
                {
                }                    

                /*the form*/
                .create-schedule-page-form   
                {
                    background-color: transparent;
                    padding-left: 0px;
                    border: ${currentTheme.pageFormBorder};   
                    border-radius: ${currentTheme.pageBorderRadius};
                }

                /*form toolbar*/
                .create-schedule-page-form > .toolbar .k-toolbar
                {
                    width: 100%;
                    border-left: none !important;
                    border-bottom: 1px solid ${currentTheme.separatorColor};
                    border-top: none !important;
                    border-right: none !important;
                    background-color: ${currentTheme.toolbarBg};/*transparent;*/
                }

                .create-schedule-page > .content .toolbar .k-button
                {
                    /*the toolbar buttons*/
                    border: none;
                    padding: 6px 8px;
                }

                .create-schedule-page > .content .toolbar .k-button-text
                {
                    /*color of the text in every toolbar button=black in azure theme*/
                    color: ${currentTheme.toolbarText};
                }

                .create-schedule-page > .content .toolbar .k-button-icon
                {
                    font-weight: 500;
                    color: ${currentTheme.primary};
                }

                .create-schedule-page > .content .form-root .k-form .k-form-field:nth-child(1)
                {
                    margin-top: 4px;
                }

                .create-schedule-page > .content .form-root .k-form .k-form-field
                {
                    margin-top: 32px;
                }

              
                .create-schedule-page > .content .form-root .content
                {
                    background-color: ${currentTheme.pageContentBg};
                }

                /*styling the popup menu */
                .k-popup ul{
                    padding: 0px;
                }

                .k-popup ul > li{
                    margin: 0;
                    padding: 0px;                                
                }

                .k-popup ul > li > span{
                    border: none !important;
                    box-shadow: none !important;
                }

                .k-menu-link{
                    padding: 0px 0px !important;
                    
                }
                `}
      </style>
    </Fragment>
  );
};
